module.exports = __webpack_public_path__ + "static/assets/0b18f02669375ad2ee80bef8d07ea7ec.mp3";